import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../app/stores/ardstore'
import { Arduino } from '../../../app/models/arduino'
interface Props {
    arduinos: Arduino[];
    arduinoId: string;
  }

export default observer(function ArduinoValueDisplay ({ arduinos, arduinoId }: Props) {
  const { arduinoStore } = useStore()
  const { setValue } = arduinoStore
  const idGiver = arduinos.find(s => s.id === arduinoId)!
  const [arduinoValue, setArduinoValue] = useState(idGiver.value)

  function checkForUpdate () {
    setValue(idGiver)
    if (arduinoStore.updatedValue) {
      if (arduinoStore.selectedArduino!.id == arduinoId) {
        setArduinoValue(arduinoStore.selectedArduino?.value!)
        arduinoStore.updatedValue = false
      }
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      checkForUpdate()
    }, 2000)
    return () => clearInterval(interval)
  }, [])
  return (
        <div>{arduinoValue}</div>
  )
})
